import { Component } from '@verndale/core';
import { calculateLeftBorderHeight } from '../utils';
import { customEvents } from '../helpers/constants';

class StoryHero extends Component {
  setupDefaults() {
    this.dom = {
      leftBorder: document.querySelector('.story-hero__left-border')
    };
    this.watchMainElement();
  }

  addListeners() {
    window.addEventListener(customEvents.leftBorderResizeTrigger, () => {
      calculateLeftBorderHeight(this.dom.leftBorder);
    });
  }

  watchMainElement() {
    const resizeObserver = new ResizeObserver(entries => {
      calculateLeftBorderHeight(this.dom.leftBorder);
    });

    resizeObserver.observe(document.querySelector('body, main'));
  }
}

export default StoryHero;
